export const WIZARD_SET_MAXIMUM_STEP = 'WIZARD_SET_MAXIMUM_STEP';
export const WIZARD_CHANGE_STEP = 'WIZARD_CHANGE_STEP';
export const WIZARD_NEXT_STEP = 'WIZARD_NEXT_STEP';
export const WIZARD_PREVIOUS_STEP = 'WIZARD_PREVIOUS_STEP';
